
















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant';
import draggable from "vuedraggable";
import { TbGoodsClass } from '@/http';
@Component({
    components: {draggable},
}) 
export default class sortPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:true
    })
    isFirst:Boolean;
    componentList=[];
    deleteList=[];

    dragOption= {
        disabled: true
      }
      Loop=null;

    async mounted() {
       if(this.isFirst){
        this.getFirstClass();
       }
    }
    async created() {
    
    }
    public change(event) {
    }
    public start(event) {
    }
    public end(event) {
        this.dragOption.disabled = true;
        // this.componentList2 = JSON.parse(JSON.stringify(this.componentList));
    }
    public move(event, orgin) {
    }
    async getFirstClass(){
        let res = await TbGoodsClass.GetAllGoodsClassList({needGoodsCount:false});
        this.componentList =res.filter(v=>v.name!='其他分类');
    }
    upFun(item,index){
        this.componentList.splice(index,1);
        this.componentList.splice(index-1,0,item)
    }
    downFun(item,index){
        this.componentList.splice(index,1);
        this.componentList.splice(index+1,0,item)
    }
    getSecondList(item){
        this.componentList = item;
    }
    deleteFun(item,index){
        this.$emit('deleteFun',item);
        // if(item.updateType==2){
        //     this.deleteList.push(item);
        // }
        // this.componentList.splice(index,1);
    }
    addItem(item){
        let form = {
            id:"",
            name:item.sname,
            updateType:1,
        }
        this.componentList.unshift(form);
    }
    datadragEnd (evt) {
    
      this.dragOption.disabled = true
   
    }

    /**退回列表-长按删除 */
    touchstart(item){
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.dragOption.disabled = false
        }.bind(this), 500);//手指或者鼠标按下等待的时间
    }
    touchend(){
        clearInterval(this.Loop);
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/sortPanel.vue